import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import { DragHandleOutlined } from '@mui/icons-material';
import RubrosTabla from '../types/RubrosTabla';
import ObtenerRubros from '../functions/ObtenerRubros';

interface ListarRubrosProps {
    defaultItemsPerPage?: number;
    handleEdit: (rubro: RubrosTabla) => void;
    handleDelete: (rubro: RubrosTabla) => void;
    handleAdd: () => void
}

export const ListarRubros: React.FC<ListarRubrosProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, }) => {
  
  const [rubros, setRubros] = useState<RubrosTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  useEffect(() => {
    const fetchRubros = async () => {
      try {
        const data = await ObtenerRubros();
        setRubros(data.rubros);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los rubros:' + err);
        setLoading(false);
      }
    };

    fetchRubros();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'rubro', label: 'RUBRO', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dado_de_baja', label: 'DADO DE BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (rubro: RubrosTabla) => {
    handleEdit(rubro);
  };

  const handleDeleteLocal = (rubro: RubrosTabla) => {
    handleDelete(rubro);
  };

  const handleCredencialLocal = (rubro: RubrosTabla) => {
    console.log('Mostrar credencial', rubro);
  }

  const handleUbicationLocal = (rubro: RubrosTabla) => {
    console.log('Mostrar ubicacion', rubro);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Rubros cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nuevo Rubro</button>
        </div>
      </div>
      <Tabla columns={columns} data={rubros} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleCredencialLocal} onUbication={handleUbicationLocal} acciones={['editar','eliminar']}/>
    </div>
  );
};